<template>
  <Layout>
    <b-modal
      id="signup-modal"
      v-model="termsModalShow"
      title="Términos y condiciones"
      size="lg"
      hide-footer
      >
      <TermsAndConditions />
    </b-modal>
    <div class="row justify-content-center pt-4 mb-2"> 
      <div class="col-12 col-md-10 col-lg-10 col-xl-9">
        <h4>Registro de usuario</h4>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-10 col-xl-9">
        <div class="card bg-pattern" >
          <div class="card-body p-4 pb-0">
            <div class="text-center m-auto">
              <a href="/">
                <span>
                  <img
                    src="@assets/images/alcaldia-logo-texto.svg"
                    alt="login" height="100"
                  />
              </span>
              </a>
              <p class="text-muted mt-2">Caracterización 360</p>
            </div>

            <div class="row mb-3">
              <h5>Datos básicos</h5>
            </div>

            <b-alert v-model="isRegisterError" variant="danger" dismissible>
              {{regError}}
            </b-alert>

            <b-form @submit.prevent="tryToRegisterIn">
              <div class="row">
                <div class="col-12 col-md-6 col-xl-3">
                  <b-form-group
                    label-for="fullname"
                  >
                    <template #label>
                      <label>Documento de identidad <span class="required-field">*</span></label>
                    </template>
                    <div class="document_identity">
                      <v-select
                        class="type_document"
                        label="code"
                        v-model="usuario.type_document"
                        disabled
                        :options="allDocuments"
                      />
                      <b-form-input
                        id="number_document"
                        v-model="usuario.number_document"
                        type="number"
                        disabled
                        required
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <b-form-group
                    label="Nombres"
                    label-for="fullname"
                  >
                    <template #label>
                      <label>Nombres <span class="required-field">*</span></label>
                    </template>
                    <b-form-input
                      type="text"
                      name="fullname"
                      v-model="$v.usuario.fullname.$model"
                      @blur="$v.usuario.fullname.$touch()"
                      :class="{ error: $v.usuario.fullname.$error }"
                    />
                    <span
                      v-if="$v.usuario.fullname.$error"
                      class="help-block text-left text-error-input"
                    >
                      {{ messageValidation($v.usuario.fullname) }}
                    </span>
                    <span class="help-block text-left text-error-input" v-else>
                      &nbsp;
                    </span>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6 col-xl-3"> 
                  <b-form-group
                    label="Apellidos"
                    label-for="fullname"
                  >
                    <template #label>
                      <label>Apellidos <span class="required-field">*</span></label>
                    </template>
                    <b-form-input
                      id="lastname"
                      type="text"
                      v-model="$v.usuario.lastname.$model"
                      @blur="$v.usuario.lastname.$touch()"
                      :class="{ error: $v.usuario.lastname.$error }"
                    />
                    <span
                      v-if="$v.usuario.lastname.$error"
                      class="help-block text-left text-error-input"
                    >
                      {{ messageValidation($v.usuario.lastname) }}
                    </span>
                    <span class="help-block text-left text-error-input" v-else>
                      &nbsp;
                    </span>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <b-form-group
                    label="Género"
                    label-for="fullname"
                  >
                    <template #label>
                      <label>Género <span class="required-field">*</span></label>
                    </template>
                    <v-select
                      class="custom-form-control"
                      v-model="$v.usuario.gender.$model"
                      @open="$v.usuario.gender.$touch()"
                      :class="{ error: $v.usuario.gender.$error }"
                      :options="allGenders"
                      label="description"
                    />
                    <span
                      v-if="$v.usuario.gender.$error"
                      class="help-block text-left text-error-input"
                    >
                      {{ messageValidation($v.usuario.gender) }}
                    </span>
                    <span class="help-block text-left text-error-input" v-else>
                      &nbsp;
                    </span>
                  </b-form-group>
                </div>
              </div>
              
              <div class="row">
                <div class="col-12 col-md-6 col-xl-3">
                  <b-form-group
                    class="custom-radio"
                    label="Tipo de persona"
                    label-for="email"
                  >
                    <template #label>
                      <label>Tipo de persona <span class="required-field">*</span></label>
                    </template>
                    <span v-for="item in allTypePerson" :key="item">
                      <input
                        type="radio"
                        v-model="$v.usuario.type_person.$model"
                        :value="item"
                        name="typePerson"
                      >
                      {{ item.description }}
                    </span>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <b-form-group
                    label="Correo electrónico"
                    label-for="email"
                  >
                    <template #label>
                      <label>Correo electrónico <span class="required-field">*</span></label>
                    </template>
                    <b-form-input
                      id="email"
                      v-model="$v.usuario.email.$model"
                      @blur="$v.usuario.email.$touch()"
                      :class="{ error: $v.usuario.email.$error }"
                      type="email"
                    ></b-form-input>
                    <span
                      v-if="$v.usuario.email.$error"
                      class="help-block text-left text-error-input"
                    >
                      {{ messageValidation($v.usuario.email) }}
                    </span>
                    <span class="help-block text-left text-error-input" v-else>
                      &nbsp;
                    </span>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <b-form-group
                    label="Número de contacto 1"
                    label-for="fullname"
                  >
                    <template #label>
                      <label>Número de contacto 1 <span class="required-field">*</span></label>
                    </template>
                    <div class="row">
                      <div class="col pl-1">
                        <v-select
                          key="allCountries1"
                          :options="this.allCountries"
                          v-model="usuario.selectFlagNumber"
                          :searchable="false"
                          label="name"
                        >
                        <template #selected-option="{ name, flag, phoneCode, iso3 }">
                          <div style="display: flex; align-items: center; gap: 2px">
                            <img :src="flag" alt="" width="25">
                            <strong class="text-code-country">{{ phoneCode }} - ({{iso3}})</strong>
                          </div>
                        </template>
                        <template #option="option">
                          <span><img  width="25" :src="option.flag" />{{' '}}{{ option.name }}</span>
                        </template>
                      </v-select>
                      </div>
                      <div class="col p-0"> 
                        <b-form-input
                          id="number_1"
                          v-model="$v.usuario.number_1.$model"
                          @blur="$v.usuario.number_1.$touch()"
                          :class="{ error: $v.usuario.number_1.$error }"
                          type="number"
                        ></b-form-input>
                        <span
                          v-if="$v.usuario.number_1.$error"
                          class="help-block text-left text-error-input"
                        >
                          {{ messageValidation($v.usuario.number_1) }}
                        </span>
                        <span class="help-block text-left text-error-input" v-else>
                          &nbsp;
                        </span>
                      </div>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <b-form-group
                    id="number_contact_2"
                    label="Número de contacto 2"
                    label-for="fullname"
                  >
                  <template #label>
                    <label>Número de contacto 2 <span class="opcional-field">- Opcional</span></label>
                  </template>
                    <div class="row">
                      <div class="col pl-1"> 
                        <v-select
                          key="allCountries2"
                          v-model="usuario.selectFlagNumber2"
                          :options="this.allCountries"
                          :searchable="false"
                          label="name"
                        >
                        <template #selected-option="{ name, flag, phoneCode, iso3 }">
                          <div style="display: flex; align-items: center; gap: 2px">
                            <img :src="flag" alt="" width="25">
                            <strong class="text-code-country">{{ phoneCode }} - ({{iso3}})</strong>
                          </div>
                        </template>
                        <template #option="option">
                          <span><img  width="25" :src="option.flag" />{{' '}}{{ option.name }}</span>
                        </template>
                      </v-select>
                      </div>
                      <div class="col p-0"> 
                        <b-form-input
                          id="number_2"
                          type="number"
                          v-model="usuario.number_2"
                        ></b-form-input>
                      </div>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6 col-lg-3">
                  <b-form-group
                    label="Departamento"
                    label-for="email"
                  >
                  <template #label>
                    <label>Departamento <span class="required-field">*</span></label>
                  </template>
                  <!-- v-model="selectDeparment" -->
                    <v-select
                      @input="handleChangeDeparment($event)"
                      :options="allDeparments"
                      v-model="$v.usuario.deparment.$model"
                      @open="$v.usuario.deparment.$touch()"
                      :class="{ error: $v.usuario.deparment.$error }"
                      class="custom-form-control"
                      label="description"
                    />
                    <span
                      v-if="$v.usuario.deparment.$error"
                      class="help-block text-left text-error-input"
                    >
                      {{ messageValidation($v.usuario.deparment) }}
                    </span>
                    <span class="help-block text-left text-error-input" v-else>
                      &nbsp;
                    </span>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6 col-lg-3">
                  <b-form-group
                    label="Ciudad"
                    label-for="email"
                  >
                    <template #label>
                      <label>Ciudad <span class="required-field">*</span></label>
                    </template>
                    <v-select
                      class="custom-form-control"
                      label="description"
                      :options="allMunicipaly"
                      v-model="$v.usuario.municipaly.$model"
                      @open="$v.usuario.municipaly.$touch()"
                      :class="{ error: $v.usuario.municipaly.$error }"
                    />
                    <span
                      v-if="$v.usuario.municipaly.$error"
                      class="help-block text-left text-error-input"
                    >
                      {{ messageValidation($v.usuario.municipaly) }}
                    </span>
                    <span class="help-block text-left text-error-input" v-else>
                      &nbsp;
                    </span>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-12 col-lg-3">
                  <b-form-group
                    label="Dirreción"
                    label-for="email"
                  >
                    <template #label>
                      <label>Dirreción <span class="required-field">*</span></label>
                    </template>
                    <b-form-input
                      id="email"
                      v-model="$v.usuario.address.$model"
                      @blur="$v.usuario.address.$touch()"
                      :class="{ error: $v.usuario.address.$error }"
                      type="text"
                    ></b-form-input>
                      <span
                        v-if="$v.usuario.address.$error"
                        class="help-block text-left text-error-input"
                      >
                        {{ messageValidation($v.usuario.address) }}
                      </span>
                      <span class="help-block text-left text-error-input" v-else>
                        &nbsp;
                      </span>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-8 col-lg-5">
                  <b-form-group
                    id="terms-group"
                    label=""
                    label-for="terms"
                  >
                    <b-form-checkbox
                    v-model="$v.usuario.accept_politices.$model"
                    @blur="$v.usuario.accept_politices.$touch()"
                    :class="{ error: $v.usuario.accept_politices.$error }"
                    >Acepta la
                    <a
                      @click="openTermsModal(plan)"
                      class="text-dark"> política de uso y restricciones del sistema
                    </a>
                    <label>
                      <span class="required-field">*</span>
                    </label>
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-6 col-sm-4 col-md-3 col-lg-2">
                  <b-form-group id="button-group" class="mt-4 mb-0">
                    <router-link
                      tag="a"
                      to="/login"
                      type="button"
                      class="btn btn-block btn-secondary btn-rounded waves-effect"
                      >
                      Volver
                      </router-link>
                  </b-form-group>
                </div>
                <div class="col-6 col-sm-4 col-md-3 col-lg-2">
                  <b-form-group id="button-group" class="mt-4 mb-0">
                    <b-button
                      type="submit"
                      variant="primary"
                      pill
                      class="btn-block btn-registro"
                      :disabled="!(!$v.$invalid && !isLoadingRegister)"
                      >
                        Registrarse
                        <div class="loader" v-if="isLoadingRegister"/>
                      </b-button
                      
                    >
                  </b-form-group>
                </div>
                
              </div>
            </b-form>
          </div>
        </div>
      </div>
      <div class="custom-loader" v-if="isLoading">
        <b-spinner
          label="Spinning"
          style="color: #ffffff; width: 4rem; height: 4rem"
        ></b-spinner>
      </div>
      <b-modal
        v-model="isAlertUme"
        id="alert"
        size="md"
        title="Alerta"
        ok-only
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        ok-title="Continuar"
        @ok="handleAlertUme"
      >
        <div class="row">
          <div class="col p-0">
            <p>Su usuario no se encuentra registrado en el portal del Distrito Especial de Ciencia, Tecnología e Innovación de Medellín. Por favor elaborar su registro ingresando a <a href="https://www.medellin.gov.co/registrate" target="_blank">https://www.medellin.gov.co/registrate</a></p>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>



<script>
import InputRadio from '@components/form/InputRadio'
import Layout from '@layouts/auth'
import { authMethods, commonMethods } from '@state/helpers'
import getSecret from '@utils/get-secret'
import DisableAutocomplete from 'vue-disable-autocomplete'
import Vue from 'vue'
import TermsAndConditions from '@components/terms'
import { validationMixin } from '../../mixins'
import { required, email, numeric  } from "vuelidate/lib/validators"

Vue.use(DisableAutocomplete);

export default {
  page: {
    title: 'Register',
    meta: [{ name: 'description', content: `Register to ${getSecret('TITLE')}` }],
  },
  mixins: [validationMixin],
  components: { Layout, TermsAndConditions, InputRadio },
  data() {
    return {
      _value: '',
      isLoadingRegister: false,
      isAlertUme: false,
      usuario: {
        number_document: '',
        type_document: '',
        type_person: '',
        fullname: '',
        lastname: '',
        gender: '',
        email: '',
        number_1: '',
        number_2: '',
        deparment: '',
        municipaly: '',
        address: '',
        accept_politices: false,
        selectFlagNumber: '',
        selectFlagNumber2: ''
      },
      terms: null,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      termsModalShow: false,
      allDeparments: [],
      allCountries: [],
      allMunicipaly: [],
      allMunicipalyCharge: [],
      allDocuments: [],
      allTypePerson: [],
      allGenders: [],
      selectDeparment: null,
      isLoading: false,
      isBusy: false
    }
  },
  validations: {
    usuario: {
      fullname: {
        required,
      },
      lastname: {
        required,
      },
      gender: {
        required,
      },
      email: {
        required,
        email
      },
      number_1: {
        required,
        numeric
      },
      deparment: {
        required,
      },
      municipaly: {
        required,
      },
      address: {
        required,
      },
      accept_politices: {
        required,
        checked: value => value === true
      },
      type_person: {
        required
      }
    },
  },
  computed: {
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null
    },
    passwordType() {
      return this.hidePassword ? 'password' : 'text'
    },
    passwordIcon() {
      return this.hidePassword ? 'fa-eye' : 'fa-eye-slash'
    },
    passwordType2() {
      return this.hidePassword ? 'password' : 'text'
    },
    passwordIcon2() {
      return this.hidePassword ? 'fa-eye' : 'fa-eye-slash'
    }
  },
  async mounted  () {
    this.isLoading = true
    await Promise.all([this.fetchAllCountry('?page_size=500'), this.fetchAllFlags(), this.fetchAllMunicipality('?page_size=2000'), this.fetchAllDeparment('?page_size=500')])
      .then(([ countries, flags, municipaly, departments])=> {
        this.allDeparments = departments
        this.allMunicipalyCharge = municipaly
        this.allCountries = countries.map((countrie) => {
          for (const item of flags) {
            if (countrie && (item['cca3'] === countrie.iso3 || item['fifa'] === countrie.iso3 || item['name'].common === countrie.name)) {
              return { ...countrie, flag: item['flags']['png'] };
            }
          }
        }).filter(countrie => countrie !== undefined);
        const defaultFlag = this.allCountries.find((item) => item.name.toLowerCase() === 'colombia')
        this.usuario.selectFlagNumber = defaultFlag
        this.usuario.selectFlagNumber2 = defaultFlag
      })
      .catch(err => console.error(err));
    
    await Promise.all([this.fetchAllMasters('1'), this.fetchAllMasters('2'), this.fetchAllMasters('3')])
    .then(([ documents, typePerson, genders ]) => {
      this.allDocuments = documents.master_details
      this.allTypePerson = typePerson.master_details
      this.allGenders = genders.master_details
    })

    this.getUser(this.$route.params.document).then((response) => {
      if (response.success !== '0') {
        const {usuario} = response
        const genderAsing = this.allGenders.find((gender) => gender.code.toLowerCase() === usuario.genero.toLowerCase())

        const city = this.allMunicipalyCharge.find(munici => munici.ume === usuario.ciudad)
        const deparment = this.allDeparments.find(depart => (depart.id === city.department))
        this.handleChangeDeparment(deparment)
        this.usuario.type_document = this.allDocuments.find((doc) => {
          return usuario.tipo_documento.split('-')[1].normalize("NFD").includes(doc.description.normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
        })

        this.usuario.deparment = deparment
        this.usuario.municipaly = city
        this.usuario.number_document = this.$route.params.document
        this.usuario.fullname = usuario.nombres
        this.usuario.lastname = usuario.apellidos
        this.usuario.gender = genderAsing
        this.usuario.email = usuario.correo
        this.usuario.number_1 = usuario.telefono
        this.usuario.address = usuario.direccion
        this.usuario.type_person = this.allTypePerson.find(item => {
          return usuario.tipo_sociedad.split('-')[1].includes(item.description)
        })
        this.isLoading = false
      } else {
        this.isLoading = false
        this.isAlertUme = true
      }
    })
  },
  methods: {
    ...commonMethods,
    ...authMethods,
    handleAlertUme () {
      this.$router.push({
        name: 'login'
      })
    },
    handleChangeDeparment(newValue) {
      this.allMunicipaly = this.allMunicipalyCharge.filter((muni) => newValue.id == muni.department)
    },
    openTermsModal(plan) {
      this.planToChoose = plan
      this.termsModalShow = !this.termsModalShow
      return false
    },
    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToRegisterIn() {
      this.tryingToRegister = true
      this.isRegisterError = false
      if (!this.$v.$invalid) {
        this.regError = null
        this.isLoadingRegister = true
        return this.register({
          address: this.usuario.address,
          document: this.usuario.number_document,
          documentTypeId: this.usuario.type_document.id,
          email: this.usuario.email,
          genderId: this.usuario.gender.id,
          lastName: this.usuario.lastname,
          municipalyId: this.usuario.municipaly.id,
          name: this.usuario.fullname,
          nit: '',
          personTypeId: this.usuario.type_person.id,
          phoneOne: this.usuario.number_1,
          phoneOneCountry: this.usuario.selectFlagNumber.phoneCode,
          phoneTwo: this.usuario.number_2 ? this.usuario.number_2 : null,
          phoneTwoCountry: this.usuario.selectFlagNumber2.phoneCode,
          socialReason: null,
          ume: false,
          usagePolicy: this.usuario.accept_politices,
        })
        .then(() => {
          this.tryingToRegister = false
          this.isRegisterError = false
          this.isBusy = false
          // Redirect to the originally requested page, or to the confirm-account page
          this.$router.push(this.$route.query.redirectFrom || { name: 'confirm-account' })
          this.isLoadingRegister = false
        })
        .catch((error) => {
          this.tryingToRegister = false
          if (error.response.data.username) {
            this.regError = "El usuario ya se encuentra registrado en el sistema."
          } else {
            this.regError = "Ocurrió un error"
          }
          this.isRegisterError = true
          this.isLoadingRegister = false
        })
      }
    },
  },
}
</script>



<style lang="scss" >
  .v-select.vs--unsearchable input[type="search"] {
    display: none;
  }

  .document_identity {
    display: flex;
    gap: 16px;
    justify-content: space-between;
  }

  .type_document {
    width: 140px;
  }

  .custom-form-control {
    border-radius: 6px !important;
  }

  .custom-form-control.error > div {
    border: 1px solid #ad0808 !important;
  }

  .custom-radio > div {
    display: flex;
    align-items: center;
    gap: 16px;

    span {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .text-dark {
    cursor: pointer;
    color: #1faeef !important;
  }

  .text-code-country {
    font-size: 10px !important;
  }

  .custom-loader {
    z-index: 4;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

    width: 100%;
    height: 100%;
    background-color: rgba(81, 81, 81, 0.489);
    position: fixed;
  }

  .custom-loader > span {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .required-field {
    color: #ff0000;
  }

  .btn-registro {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .opcional-field {
    font-size: 8px;
  }

  .loader {
    border: 0.25rem solid #f3f3f3;
    border-radius: 50%;
    border-top: 0.25rem solid #1FAEEF;
    width: 1.2rem;
    height: 1.2rem;
    animation: spin 1s linear infinite;
    margin-left: 0.625rem;
    -webkit-animation: spin 1s linear infinite;
  }
</style>
